import React from 'react';
import { get } from 'lodash';

import { FIELD_PATHS } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { LiabilityEntityIndex } from '@funnels/types';
import { validateNumberLessThanOrEqualTo } from '@funnels/utils';

import { DollarInputField, NumeralDisplay } from '../../Fields';
import { NumericalReadOnlyViewProps } from '../types';

interface NewLimitEditableViewProps extends LiabilityEntityIndex {
  label?: string;
  isDisabled?: boolean;
  isOptional?: boolean;
  disableFailMessage?: boolean;
  validationFailMessage?: string;
}

export const NewLimitEditableView = (props: NewLimitEditableViewProps) => {
  const [formValues] = useFormValues();
  const creditLimit = get(formValues, FIELD_PATHS.LIABILITY_CREDIT_LIMIT(props.liabilityIndex));

  return (
    <DollarInputField
      name={FIELD_PATHS.LIABILITY_NEW_LIMIT(props.liabilityIndex)}
      label={props.label}
      validate={validateNumberLessThanOrEqualTo(
        props.validationFailMessage || 'The ongoing limit must be less than or equal to the credit limit',
        creditLimit
      )}
      isDisabled={props.isDisabled}
      isOptional={props.isOptional}
      disableFailMessage={props.disableFailMessage}
      isZeroValid
    />
  );
};

export const NewLimitReadOnlyView = (props: NumericalReadOnlyViewProps) => <NumeralDisplay before={'$'} {...props} />;
